import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";


const PrivacyPolicy: React.FC = () => {






    const navigate = useNavigate();

    const handleBackClick = () => {
        const path = sessionStorage.getItem("previousPath");
        if (path) {
            navigate(path);
        } else {
            navigate("/home");
        }
    };








    return (
        <>
            <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] text-white faq">
                <header className="flex gap-3 items-center self-start text-base font-medium text-center text-white mb-[0.5rem]">
                <div>
                    <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                        onClick={() => handleBackClick()}
                    >
                        <ArrowBackIcon
                            className="text-border-color aspect-square w-[18px]"
                            style={{ width: '20px', height: '20px' }}
                        />
                    </div>
                </div>
                <h1 className="self-stretch text-xl my-auto">Privacy Policy For Strike</h1>
                </header>
                {/* <h1 className="text-xl font-medium mb-4">Pricacy Policy For Strike</h1> */}
                <p className="text-gray-400 font-medium">Effective Date: 1st Jan 2025</p>
                <span className="text-lg">1. Introduction</span>
                <p className="text-gray-400 font-medium">Welcome to Strike! We value your privacy and are committed to protecting your personal data.
                    This Privacy Policy explains how we collect, use, and safeguard your information when you use our Telegram gaming bot.</p>
                <span className="text-lg">2. Information We Collect</span>
                <p className="text-gray-400 font-medium">When you interact with Strike, we may collect the following types of information:
                    <br />
                    Telegram User Data: Username, User ID , Phone number ( upon user confirmation )
                    Gameplay Data: Game activity, scores, and in-game preferences.</p>
                <span className="text-lg">3. How we use your Information </span>
                <p className="text-gray-400 font-medium">We use your data to: <br />
                    ✅ Provide access to games and features.  <br />
                    ✅ Improve and personalize your gaming experience.  <br />
                    ✅ Prevent fraud and ensure fair gameplay.  <br />
                    ✅ Communicate updates, promotions, or support-related messages.</p>

                <span className="text-lg">4. Data Sharing And Security</span>
                <p className="text-gray-400 font-medium">🔐 We do not sell, rent, or trade your personal data.<br />
                    🔐 Your data is stored securely and used only for gaming purposes.</p>
                <span className="text-lg">5. User Control & Rights</span>
                <p className="text-gray-400 font-medium">You have the right to:  <br />
                    ⚡ Request data deletion.  <br />
                    ⚡ Update or modify your information.  <br />
                    ⚡ Opt-out of promotional messages.
                </p>
                <span className="text-lg">6. Changes to the Policy</span>
                <p className="text-gray-400 font-medium">We may update this Privacy Policy from time to time. Continued use of the bot after changes implies acceptance.
                </p> <span className="text-lg">7. Contact Us</span>
                <p className="text-gray-400 font-medium">If you have any questions, concerns, or requests regarding your data, please contact us at: @strike46_bot</p>
                <p className="text-gray-400 font-medium">📌 By using Strike, you agree to this Privacy Policy. </p>
            </div>
        </>
    );
};

export default PrivacyPolicy;
